@if (state() === "error") {
  <app-error-data title="Something went wrong" [showRetry]="true" (retry)="pageChange.emit(currentPage())" />
}

@if (!orders() || orders()?.length === 0) {
  <div class="flex w-full flex-col items-center justify-center py-12 text-center">
    @if (isFiltersApplied()) {
      <app-empty-data
        [title]="isArabic() ? 'لا توجد طلبات تطابق معايير البحث.' : 'No orders match your current filters.'" />
    } @else {
      <app-empty-data
        [title]="isArabic() ? 'لا توجد طلبات' : 'No orders found'"
        [description]="isArabic() ? 'لم يتم إنشاء أي طلبات بعد.' : 'No orders have been created yet.'" />
    }
  </div>
} @else {
  <div class="grid grid-cols-1 gap-4 pb-6 md:grid-cols-2 lg:grid-cols-3">
    @for (order of orders(); track order.id) {
      <div
        (click)="rowClick.emit(order.id)"
        class="flex cursor-pointer flex-col gap-4 rounded-2xl border border-gray-200 bg-white p-5 shadow-sm transition hover:shadow-md">
        <div class="flex items-center justify-between">
          <span class="text-lg font-bold text-gray-900">#{{ order.id }}</span>
          <div class="flex items-center gap-2">
            <span
              class="rounded-full px-3 py-1 text-xs font-medium"
              [class]="getStatusClass(order.status?.titleEn ?? '')">
              {{ isArabic() ? order.status?.titleAr : order.status?.titleEn }}
            </span>
            <button class="text-gray-400 hover:text-gray-600">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <circle cx="12" cy="6" r="2" />
                <circle cx="12" cy="12" r="2" />
                <circle cx="12" cy="18" r="2" />
              </svg>
            </button>
          </div>
        </div>

        <div class="flex items-center gap-2 text-gray-600" [dir]="isArabic() ? 'rtl' : 'ltr'">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
            <path d="M0 0h24v24H0z" fill="none" />
            <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
              <path
                d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z" />
              <path d="m3.3 7l8.7 5l8.7-5M12 22V12" />
            </g>
          </svg>

          <span class="text-sm font-medium">{{ order.totalItems }} {{ isArabic() ? "عناصر" : "Items" }}</span>
        </div>

        <div class="flex items-center justify-between">
          <span class="text-xl font-bold text-gray-900">
            {{ order.totalPharmacyPrice | number: "1.0-2" }}
            <span class="text-sm font-normal text-gray-500">{{ isArabic() ? "ج.م" : "EGP" }}</span>
          </span>
          <div class="text-right">
            <div class="text-xs text-gray-500">{{ order.lastModifiedOn | date }}</div>
            <div class="text-xs font-medium text-gray-700">{{ order.lastModifiedBy?.fullName }}</div>
          </div>
        </div>
      </div>
    }
  </div>

  <!-- @if (totalPages() > 1) {
    <div class="flex items-center justify-center gap-3 py-6">
      <button
        (click)="pageChange.emit(currentPage() - 1)"
        [disabled]="currentPage() === 1"
        class="flex h-9 w-9 items-center justify-center rounded-lg border border-gray-200 bg-white text-gray-600 hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-40">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          viewBox="0 0 24 24">
          <polyline [attr.points]="isArabic() ? '9 18 15 12 9 6' : '15 18 9 12 15 6'" />
        </svg>
      </button>

      @for (page of totalPagesArray(); track page) {
        <button
          (click)="pageChange.emit(page)"
          [class]="
            page === currentPage()
              ? 'bgTabsColor h-9 w-9 rounded-lg text-sm font-semibold text-white'
              : 'h-9 w-9 rounded-lg border border-gray-200 bg-white text-sm text-gray-600 hover:bg-gray-50'
          ">
          {{ page }}
        </button>
      }

      <button
        (click)="pageChange.emit(currentPage() + 1)"
        [disabled]="currentPage() >= totalPages()"
        class="flex h-9 w-9 items-center justify-center rounded-lg border border-gray-200 bg-white text-gray-600 hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-40">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          viewBox="0 0 24 24">
          <polyline [attr.points]="isArabic() ? '15 18 9 12 15 6' : '9 18 15 12 9 6'" />
        </svg>
      </button>
    </div>
  } -->
}
